import currency from 'currency.js'

export const multiplyCurrency = (val1: number, val2: number) => currency(val1).multiply(val2).value

export const addCurrency = (val1: number, val2: number) => currency(val1).add(val2).value
